<script lang="ts" setup>
import { toRefs } from 'vue';

const props = withDefaults(
    defineProps<{
        nullable: boolean;
    }>(),
    {
        nullable: false,
    },
);
const { nullable } = toRefs(props);
</script>

<template>
    <div class="container">
        <slot name="top"></slot>
        <v-autocomplete
            width="90px"
            dense
            hide-details
            :clearable="nullable"
            :items="[
                { value: true, label: $t('yes') },
                { value: false, label: $t('no') },
            ]"
            item-text="label"
            item-value="value"
            :value="$attrs.value ?? (nullable ? null : false)"
            v-bind="$attrs"
            v-on="$listeners"
        />
    </div>
</template>
<style lang="scss" scoped>
.container {
    width: 120px;

    .v-input {
        padding-left: 5px;
    }
}

// overwrite of min-width: 64px
// fix: buttons outside of container
:deep(.v-autocomplete.v-select.v-input--is-focused input) {
    min-width: unset;
}
</style>
